import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';

export interface IAccountProfileGenerateRequest {
	accountId: string;
	transcriptContent: string;
	websiteUrl?: string;
}

/**
 * Response from the generate endpoint. Note: `keywords` is returned as a flat field here
 * but maps to `AccountProfile.messagingPreferences.keywords` when saving.
 */
export interface IAccountProfileGenerateResponse {
	businessDescription: string;
	keywords: string;
	contentGoals: string;
	location: string;
	address: string;
	phoneNumber: string;
	pronouns: string;
	tonePreference: string;
}

export function useAdminAccountProfileGenerateMutation() {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: (request: IAccountProfileGenerateRequest) => {
			return userSession.webServiceHelper.callAsync<IAccountProfileGenerateResponse>(
				'admin/zoom/account-profile/generate',
				'POST',
				request
			);
		},
	});
}
